import { Box, Typography, Button, Chip } from '@mui/material'
import logo from '../../assets/rounded_logo.svg'
import baltimoreBeautyImage from '../../assets/baltimore-beauty.jpg'

export default function TourRequestFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Status Bar */}
        <Box sx={{
          height: 44,
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 2,
          fontSize: '0.875rem',
          fontWeight: 600
        }}>
          <Box
            component="img"
            src={logo}
            alt="HeyProperty"
            sx={{
              height: 40,
              width: 'auto',
              maxWidth: '60px',
              marginTop: '5px'
            }}
          />
        </Box>

        {/* Property Image */}
        <Box sx={{
          width: '100%',
          height: 200,
          backgroundImage: `url(${baltimoreBeautyImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} />

        {/* Property Details */}
        <Box sx={{ p: 2 }}>
          {/* Line 1: Neighborhood and Rent */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 16, color: 'grey.800' }}>🏢</Box>
              <Typography variant="body1" sx={{ fontWeight: 600, color: 'grey.700', fontSize: '0.875rem' }}>
                Roland Park
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ fontWeight: 500, color: 'grey.800', fontSize: '0.875rem' }}>
              <span style={{ fontWeight: 800, fontFamily: 'Rye'}}>$</span>3,500
            </Typography>
          </Box>

          {/* Line 2: Bed & Bath and Match Score */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 16, color: 'grey.800' }}>🏠</Box>
              <Typography variant="body1" color="grey.700" fontWeight={600} sx={{ fontSize: '0.875rem' }}>
                5 bed • 3 bath
              </Typography>
            </Box>
            <Chip
              label="98% Match"
              size="small"
              sx={{
                bgcolor: '#228B22',
                color: 'white',
                fontWeight: 600,
                fontSize: '0.75rem',
                height: '20px',
                '& .MuiChip-label': {
                  px: 1,
                  fontSize: '0.75rem',
                  fontWeight: 600
                }
              }}
            />
          </Box>


          {/* Tour Request Section */}
          <Typography variant="h6" sx={{
            fontWeight: 700,
            fontSize: '1rem',
            color: 'grey.900',
            mb: 1.5
          }}>
            Requested Tour Time
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 14, color: 'grey.600' }}>📍</Box>
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.600' }}>
                456 Heyy Ave, Baltimore, MD
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 14, color: 'grey.600' }}>📅</Box>
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.600' }}>
                Saturday, February 17, 2026
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 14, color: 'grey.600' }}>🕐</Box>
              <Typography sx={{ fontSize: '0.75rem', color: 'grey.600' }}>
                10:00 AM
              </Typography>
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              sx={{
                flex: 1,
                borderColor: '#e5e7eb',
                color: 'grey.700',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.75rem',
                py: 0.5
              }}
            >
              ❌ Decline
            </Button>
            <Button
              variant="contained"
              sx={{
                flex: 1,
                bgcolor: 'black',
                color: 'white',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.75rem',
                py: 0.5,
                '&:hover': {
                  bgcolor: 'grey.800'
                }
              }}
            >
              ✅ Accept
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
